var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"event-teaser-list"}},[_c('ul',{staticClass:"list-wrapper"},_vm._l((_vm.getFilteredEvents),function(event){return _c('li',{key:event.uid,staticClass:"list-complete-item"},[_c('cg-event-teaser',{attrs:{"event":event.data,"uid":event.uid}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }